import { EmailInputComponent } from "./Email";
import { PassInputComponent } from "./Password";

export function FormInput() {
  return <></>;
}

FormInput.Email = EmailInputComponent;
FormInput.Password = PassInputComponent;
